import React from 'react';
import { useAppTheme } from '../Hooks/useAppTheme';

export const MiddleActionCard = ({ icon, label, sublabel, onClick }) => {
  const theme = useAppTheme();
  
  return (
    <button
      onClick={onClick}
      className="rounded-xl shadow flex flex-col items-center justify-center p-4 w-full h-36 cursor-pointer 
             hover:-translate-y-1 hover:shadow-lg transition-transform duration-200 ease-in-out"
      style={{ backgroundColor: theme.bgCard }}
    >
      <div className="text-3xl mb-2" style={{ color: theme.brandPrimary }}>{icon}</div>
      <div className="text-sm font-semibold" style={{ color: theme.textPrimary }}>{label}</div>
      <div className="text-xs" style={{ color: theme.textSecondary }}>{sublabel}</div>
    </button>
  );
};